import { css } from '@emotion/react';

export default {
  readTime: () =>
    css({
      padding: 0,
    }),
};
